import React, { useState } from "react";
import styled from "styled-components";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { FaFacebook, FaInstagram, FaLinkedin } from "react-icons/fa";
import { Link, SocialIcons } from "./Footer";
import "./component.css";

const NavBar = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [openDropdown, setOpenDropdown] = useState("");

  useGSAP(() => {
    gsap.from(".brand", { x: -20, opacity: 0, duration: 0.8 });
    gsap.from(".nav-link", {
      y: -10,
      opacity: 0,
      duration: 0.6,
      stagger: 0.1,
    });
    gsap.from(".cta-button", { x: 20, opacity: 0, duration: 0.8 });
  }, []);

  const toggleMobile = () => {
    setMobileOpen(!mobileOpen);
    if (mobileOpen) {
      setOpenDropdown("");
    }
  };

  const toggleDropdown = (name) => {
    if (openDropdown === name) {
      setOpenDropdown("");
    } else {
      setOpenDropdown(name);
    }
  };

  //   const navItems = ["Insuance Guides
  // Wealthies Shield
  // Advisors
  // Blog
  // About
  // contact
  // CTAButon"];

  return (
    <Header>
      <TopBar>
        <div className="contact">
          <a href="tel:+918904499932">
            📞 <b>+918904499932</b>{" "}
          </a>
          |
          <a href="mailto:contact@wealthies.in">
            <b> contact@wealthies.in </b>
          </a>
        </div>

        <SocialIcons className="nav-socials">
          <Link href="https://www.facebook.com/people/Wealthiesin/61578543297980/">
            <FaFacebook />
          </Link>
          {/* <Link href="/">
            <FaTwitter />
          </Link> */}
          <Link href="/">
            <FaLinkedin />
          </Link>
          <Link href="https://www.instagram.com/wealthies.in?igsh=MW1xODdoM2c1dWdtag%3D%3D">
            <FaInstagram />
          </Link>
        </SocialIcons>
      </TopBar>
      <Nav>
        <Brand className="brand">
          <a href="/">Wealthies.in</a>
        </Brand>
        <Hamburger onClick={toggleMobile} className={mobileOpen ? "open" : ""}>
          <span></span>
          <span></span>
          <span></span>
        </Hamburger>
        <Menu className={mobileOpen ? "open" : ""}>
          {/* <NavItem href="/" className="nav-link">
            Home
          </NavItem>

          <NavItem href="/about-us" className="nav-link">
            About Us
          </NavItem> */}

          {/* <Dropdown>
            <DropdownToggle
              className="nav-link"
              onClick={() => toggleDropdown("services")}
            >
              Savings ▾
            </DropdownToggle>
            <DropdownContent $open={openDropdown === "services"}>
              <a href="endowment-plans">Endowment Plans</a>
              <a href="public-provident-fund">Public Provident Fund</a>
              <a href="fixed-deposit">Fixed Deposit</a>
              <a href="savings-bank-account">Savings Bank Account</a>
              <a href="recurring-deposit">Recurring Deposit</a>

              <a href="atal-pension-yojana">Atal Pension Yojana</a>
              <a href="national-savings-certificate">
                National Savings Certificate
              </a>
              <a href="unit-linked-insurance-plans">
                Unit-Linked Insurance Plans
              </a>
            </DropdownContent>
          </Dropdown> */}

          <Dropdown>
            <DropdownToggle
              className="nav-link"
              onClick={() => toggleDropdown("InsuanceGuides")}
            >
              Insurance ▾
            </DropdownToggle>
            <DropdownContent $open={openDropdown === "InsuanceGuides"}>
              <a href="/insurance-guides">Insurance Basics</a>
              <a href="/term-insurance">Term Insurance</a>
              <a href="/life-insurance">Life Insurance</a>
              <a href="/health-insurance">Health Insurance</a>
              <a href="/motor-insurance">Motor Insurance</a>

              {/* <a href="/business-insurance">Business Insurance</a> */}
              {/* <a href="/travel-insurance">Travel Insurance</a> */}
              {/* <a href="/home-insurance">Home Insurance</a> */}
              {/* <a href="/personal-accidental-insurance">
                Personal Accidendental Insurance
              </a> */}
            </DropdownContent>
          </Dropdown>

          <Dropdown>
            <DropdownToggle
              className="nav-link"
              onClick={() => toggleDropdown("WealthiesShield")}
            >
              Advisors ▾
            </DropdownToggle>
            <DropdownContent $open={openDropdown === "WealthiesShield"}>
              <a href="/advisors">Find an Advisor</a>
              <a href="/for-advisors">For Insurance Advisors</a>
              {/* <a href="/professional-tax">Professional Tax</a>
              <a href="/property-tax">Property Tax</a>
              <a href="/customs-duty">Customs Duty</a>
              <a href="/securities-transaction-tax">
                Securities Transaction Tax
              </a> */}
            </DropdownContent>
          </Dropdown>

          <NavItem href="/wealthies-shield" className="nav-link">
            <span className="wealthiesSHieldGradientColor">
              Wealthies Shield
            </span>
          </NavItem>
          <NavItem href="/about-us" className="nav-link">
            About Us
          </NavItem>
          <NavItem href="/contact-us" className="nav-link">
            Contact
          </NavItem>
          <NavItem href="/blog" className="nav-link">
            Blog
          </NavItem>

          <CTAButton className="cta-button">
            <a href="tel:+918904499932"> Let's Talk 📞</a>
          </CTAButton>
        </Menu>
      </Nav>
    </Header>
  );
};

export default NavBar;

const Header = styled.header`
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 999;
`;

const TopBar = styled.div`
  background: rgba(255, 255, 255, 0.6); /* semi-transparent */
  backdrop-filter: blur(6px); /* ✅ blurred background */
  font-size: 0.85rem;
  color: #333;
  display: flex;
  justify-content: space-between;
  padding: 0.5rem 2rem;
  z-index: 1000;
  position: relative;
  a {
    color: #005f73;
    text-decoration: none;
  }

  .socials a {
    margin-left: 1rem;
    text-decoration: none;
    color: #333;

    &:hover {
      color: #005f73;
    }
  }

  @media (max-width: 768px) {
    display: none;
    flex-direction: column;
    gap: 0.5rem;
    text-align: center;
  }
`;

const Nav = styled.nav`
  background: rgba(255, 255, 255, 0.6); /* semi-transparent white */
  backdrop-filter: blur(6px); /* ✅ blurred background */
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 2rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  z-index: 1000;
  position: relative;

  a {
    text-decoration: none;
    color: #1a1a1a;
  }
`;

const Brand = styled.div`
  font-weight: 700;
  font-size: 1.8rem;
  cursor: pointer;
  a {
    color: #1a1a1a;
    text-decoration: none;
  }
  a img {
    height: 40px;
    width: 40px;
    vertical-align: top;
  }
`;

const Hamburger = styled.div`
  display: none;
  flex-direction: column;
  cursor: pointer;

  span {
    background: #1a1a1a;
    height: 3px;
    width: 25px;
    margin: 4px 0;
    transition: 0.3s;
  }

  &.open span:nth-child(1) {
    transform: rotate(45deg) translate(5px, 5px);
  }
  &.open span:nth-child(2) {
    opacity: 0;
  }
  &.open span:nth-child(3) {
    transform: rotate(-45deg) translate(5px, -5px);
  }

  @media (max-width: 992px) {
    display: flex;
  }
`;

const Menu = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;

  @media (max-width: 992px) {
    position: absolute;
    top: 100%;
    left: 0;
    flex-direction: column;
    align-items: flex-start;
    background: #fff;
    width: 100%;
    overflow: hidden;
    max-height: 0;
    transition:
      max-height 0.4s ease,
      padding 0.4s ease;
    padding: 0;
    gap: 0.5rem;

    &.open {
      max-height: 1000px;
      padding: 1rem 2rem;
    }

    .nav-link {
      width: 100%;
      padding: 0.75rem 0;
      border-bottom: 1px solid #eee;
    }
  }
`;

const NavItem = styled.a`
  color: #1a1a1a;
  text-decoration: none;
  position: relative;
  cursor: pointer;

  &:hover {
    color: #005f73;
  }

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: -3px;
    height: 2px;
    width: 0;
    background: #005f73;
    transition: 0.3s;
  }

  &:hover::after {
    width: 100%;
  }
`;

const Dropdown = styled.div`
  position: relative;
  width: 100%;

  @media (min-width: 993px) {
    width: auto;
    &:hover div {
      opacity: 1;
      visibility: visible;
      transform: translateY(0);
    }
  }
`;

const DropdownToggle = styled.span`
  ${NavItem};
  display: block;
  width: 100%;
`;

const DropdownContent = styled.div`
  position: absolute;
  /* top: 2.2rem; */
  left: 0;
  background: #fff;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
  opacity: ${(p) => (p.$open ? 1 : 0)};
  visibility: ${(p) => (p.$open ? "visible" : "hidden")};
  transform: ${(p) => (p.$open ? "translateY(0)" : "translateY(10px)")};
  transition: all 0.3s ease;
  min-width: 250px;
  display: flex;
  flex-direction: column;
  max-height: 400px; /* ✅ Added scroll height */
  overflow-y: auto; /* ✅ Enables scrolling */
  scrollbar-width: thin; /* ✅ Firefox */
  scrollbar-color: #ccc transparent;

  a {
    text-decoration: none;
    color: #1a1a1a;
    padding: 0.75rem 1.5rem;

    &:hover {
      background: #f5f5f5;
    }
  }

  @media (max-width: 992px) {
    position: relative;
    box-shadow: none;
    transform: none;
    background: none;
    opacity: 1;
    visibility: visible;
    overflow: hidden;

    max-height: ${(p) => (p.$open ? "400px" : "0")}; /* Limit visible height */
    overflow-y: ${(p) => (p.$open ? "auto" : "hidden")}; /* Scroll if open */
    transition: max-height 0.4s ease;
    border-radius: 0;
    padding-left: 1rem;

    a {
      padding: 0.5rem 0;
      display: block;
    }

    /* Optional smooth scrollbar styling */
    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      background: #ccc;
      border-radius: 3px;
    }
  }
`;

const CTAButton = styled.button`
  background: #005f73;
  border: none;
  color: #fff;
  border-radius: 5px;
  padding: 0.5rem 1.5rem;
  font-weight: 600;
  cursor: pointer;
  transition: 0.3s;

  &:hover {
    background: #005f73;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(0, 119, 204, 0.3);
  }

  a {
    color: #fff;
    text-decoration: none;
  }
`;
